module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 121);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Clickable");

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ JSONTree_JSONTree; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/Clickable"
var Clickable_ = __webpack_require__(11);
var Clickable_default = /*#__PURE__*/__webpack_require__.n(Clickable_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/JSONTree/TreeNodeStyles.ts



var typeColor = {
  string: Object(themes_["pick"])({
    enterprise: {
      dark: '#00b0b3',
      light: '#00787A'
    },
    prisma: themes_["variables"].syntaxTeal
  }),
  number: Object(themes_["pick"])({
    enterprise: {
      dark: '#8bacfd',
      light: '#1f5df9'
    },
    prisma: themes_["variables"].syntaxBlue
  }),
  "boolean": Object(themes_["pick"])({
    enterprise: {
      dark: '#af8aff',
      light: themes_["variables"].syntaxPurple
    },
    prisma: themes_["variables"].syntaxPurple
  }),
  "null": Object(themes_["pick"])({
    enterprise: {
      dark: '#f0b375',
      light: '#ad5700'
    },
    prisma: themes_["variables"].syntaxBrown
  }),
  object: themes_["variables"].contentColorDefault
};
var wrap = Object(external_styled_components_["css"])(["word-break:break-word;word-wrap:break-word;"]);
var TreeNodeStyles_scroll = Object(external_styled_components_["css"])(["white-space:nowrap;"]);
var StyledValue = external_styled_components_default.a.span.withConfig({
  displayName: "TreeNodeStyles__StyledValue",
  componentId: "sc-1rdul18-0"
})(["color:", ";", ";"], function (_ref) {
  var valueType = _ref.valueType;
  return typeColor[valueType];
}, function (_ref2) {
  var overflowType = _ref2.overflowType;
  return overflowType === 'wrap' ? wrap : TreeNodeStyles_scroll;
});
var StyledValueInteractiveClickable = external_styled_components_default()(StyledValue.withComponent(Clickable_default.a)).withConfig({
  displayName: "TreeNodeStyles__StyledValueInteractiveClickable",
  componentId: "sc-1rdul18-1"
})(["font-family:inherit;&:focus{box-shadow:0 0 1px 3px ", ";outline:0;&:active{box-shadow:none;}}&:hover{background-color:", ";}"], themes_["variables"].focusColor, Object(themes_["pick"])({
  enterprise: themes_["variables"].backgroundColorHover,
  prisma: themes_["variables"].interactiveColorOverlayHover
}));
var StyledProperty = external_styled_components_default.a.span.withConfig({
  displayName: "TreeNodeStyles__StyledProperty",
  componentId: "sc-1rdul18-2"
})(["font-weight:bold;color:", ";"], Object(themes_["pick"])({
  enterprise: {
    dark: '#ec9f98',
    light: themes_["variables"].syntaxRed
  },
  prisma: themes_["variables"].syntaxRed
}));
var StyledPropertyInteractiveClickable = external_styled_components_default()(StyledProperty.withComponent(Clickable_default.a)).withConfig({
  displayName: "TreeNodeStyles__StyledPropertyInteractiveClickable",
  componentId: "sc-1rdul18-3"
})(["font-family:inherit;&:focus{box-shadow:0 0 1px 3px ", ";outline:0;&:active{box-shadow:none;}}&:hover{background-color:", ";}"], themes_["variables"].focusColor, Object(themes_["pick"])({
  enterprise: themes_["variables"].backgroundColorHover,
  prisma: themes_["variables"].interactiveColorOverlayHover
}));
var StyledExpandLinkClickable = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "TreeNodeStyles__StyledExpandLinkClickable",
  componentId: "sc-1rdul18-4"
})(["cursor:pointer;color:", ";font-family:inherit;&:hover{background-color:", ";text-decoration:none;}&:focus{box-shadow:", ";&:active{box-shadow:none;}}", ""], Object(themes_["pick"])({
  enterprise: {
    dark: themes_["variables"].accentColorL20,
    light: themes_["variables"].accentColorD20
  },
  prisma: themes_["variables"].interactiveColorPrimary
}), Object(themes_["pick"])({
  enterprise: themes_["variables"].backgroundColorHover,
  prisma: themes_["variables"].interactiveColorOverlayHover
}), themes_["variables"].focusShadowInset, Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["border-radius:", ";"], themes_["variables"].borderRadius)
}));

// CONCATENATED MODULE: ./src/JSONTree/TreeNode.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var propTypes = {
  path: external_prop_types_default.a.arrayOf(external_prop_types_default.a.string),
  defaultOpen: external_prop_types_default.a.bool,
  expandChildren: external_prop_types_default.a.bool,
  indent: external_prop_types_default.a.number,
  indentLevel: external_prop_types_default.a.number,
  obj: external_prop_types_default.a.oneOfType([external_prop_types_default.a.object, external_prop_types_default.a.array, external_prop_types_default.a.number, external_prop_types_default.a.string, external_prop_types_default.a.bool]).isRequired,
  onClickKey: external_prop_types_default.a.func,
  onClickValue: external_prop_types_default.a.func,
  overflow: external_prop_types_default.a.oneOf(['wrap', 'scroll'])
};
var defaultProps = {
  path: [],
  defaultOpen: false,
  expandChildren: false,
  indent: 4,
  indentLevel: 1,
  overflow: 'scroll'
};

/**
 * An internal container class for expandable tree nodes (objects and arrays).
 */
var TreeNode_JSONTreeNode = /*#__PURE__*/function (_Component) {
  _inherits(JSONTreeNode, _Component);

  var _super = _createSuper(JSONTreeNode);

  function JSONTreeNode(props) {
    var _this;

    _classCallCheck(this, JSONTreeNode);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "regularIndent", void 0);

    _defineProperty(_assertThisInitialized(_this), "closingIndent", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleExpandClick", function () {
      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickKey", function (e, key) {
      var _this$props$onClickKe, _this$props;

      var path = _this.props.path; // When rendering a single value key is not present, here we prevent `[undefined]` in path

      var keyPath = key !== undefined ? [].concat(_toConsumableArray(path), [key]) : _toConsumableArray(path);
      var keyPathString = ".".concat(keyPath.join('.'));
      (_this$props$onClickKe = (_this$props = _this.props).onClickKey) === null || _this$props$onClickKe === void 0 ? void 0 : _this$props$onClickKe.call(_this$props, e, {
        key: keyPathString,
        keyPath: keyPath
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickValue", function (e, key) {
      var _this$props$onClickVa, _this$props2;

      var path = _this.props.path; // When rendering a single value key is not present, here we prevent `[undefined]` in path

      var keyPath = key !== undefined ? [].concat(_toConsumableArray(path), [key]) : _toConsumableArray(path);
      var keyPathString = ".".concat(keyPath.join('.'));
      (_this$props$onClickVa = (_this$props2 = _this.props).onClickValue) === null || _this$props$onClickVa === void 0 ? void 0 : _this$props$onClickVa.call(_this$props2, e, {
        key: keyPathString,
        keyPath: keyPath,
        value: e.target.textContent // TS: cannot be null in this component, see textContent docs

      });
    });

    _this.state = {
      open: props.defaultOpen
    };
    _this.regularIndent = Object(external_lodash_["fill"])(Array(props.indentLevel), Object(external_lodash_["repeat"])("\xA0", props.indent));
    _this.closingIndent = Object(external_lodash_["fill"])(Array(props.indentLevel - 1), Object(external_lodash_["repeat"])("\xA0", props.indent));
    return _this;
  }

  _createClass(JSONTreeNode, [{
    key: "renderExpandLink",
    value: function renderExpandLink() {
      return /*#__PURE__*/external_react_default.a.createElement(StyledExpandLinkClickable, {
        onClick: this.handleExpandClick,
        "aria-expanded": this.state.open,
        "data-test": "toggle"
      }, "\xA0", this.state.open ? '[-]' : '[+]', "\xA0");
    }
  }, {
    key: "renderValue",
    value: function renderValue(_ref) {
      var _this2 = this;

      var value = _ref.value,
          key = _ref.key;
      var _this$props3 = this.props,
          indent = _this$props3.indent,
          indentLevel = _this$props3.indentLevel,
          onClickKey = _this$props3.onClickKey,
          onClickValue = _this$props3.onClickValue,
          expandChildren = _this$props3.expandChildren,
          overflow = _this$props3.overflow,
          path = _this$props3.path;
      var isPrimitive = !Object(external_lodash_["isObject"])(value); // isObject is true for arrays

      var representation = value; // determine if value should be represented as a simple string
      // or as a child node

      if (!isPrimitive) {
        if (Object(external_lodash_["isEmpty"])(value)) {
          representation = Object(external_lodash_["isArray"])(value) ? '[]' : '{}';
        } else {
          representation = /*#__PURE__*/external_react_default.a.createElement(JSONTreeNode, {
            obj: value,
            path: key !== undefined ? [].concat(_toConsumableArray(path), [key]) : _toConsumableArray(path) // Prevent undefined from being added to path for single value edge-case
            ,
            defaultOpen: expandChildren,
            expandChildren: expandChildren,
            onClickKey: onClickKey,
            onClickValue: onClickValue,
            indent: indent,
            indentLevel: indentLevel + 1,
            overflow: overflow
          });
        }
      } else if (typeof value === 'string') {
        representation = "\"".concat(value, "\"");
      } else if (typeof value === 'boolean') {
        representation = value.toString();
      } else if (value === null) {
        representation = 'null';
      } // for string or number representations, apply styles and optional interactivity


      if (Object(external_lodash_["isString"])(representation) || Object(external_lodash_["isNumber"])(representation)) {
        var valueType = value === null ? 'null' : // TS: bigint, function, symbol are prevented by JSONElement type
        _typeof(value);

        if (onClickValue) {
          return /*#__PURE__*/external_react_default.a.createElement(StyledValueInteractiveClickable, {
            valueType: valueType,
            overflowType: overflow,
            onClick: function onClick(e) {
              _this2.handleClickValue(e, key);
            }
          }, representation);
        }

        return /*#__PURE__*/external_react_default.a.createElement(StyledValue, {
          valueType: valueType,
          overflowType: overflow
        }, representation);
      }

      return representation;
    }
  }, {
    key: "renderKey",
    value: function renderKey(key) {
      var _this3 = this;

      var onClickKey = this.props.onClickKey;

      if (onClickKey) {
        return /*#__PURE__*/external_react_default.a.createElement("span", null, /*#__PURE__*/external_react_default.a.createElement(StyledPropertyInteractiveClickable, {
          onClick: function onClick(e) {
            _this3.handleClickKey(e, key);
          }
        }, key));
      }

      return /*#__PURE__*/external_react_default.a.createElement("span", null, /*#__PURE__*/external_react_default.a.createElement(StyledProperty, null, key), ":", ' ');
    }
  }, {
    key: "renderObject",
    value: function renderObject() {
      var _this4 = this;

      var _this$props4 = this.props,
          obj = _this$props4.obj,
          path = _this$props4.path;

      if (Object(external_lodash_["isObject"])(obj) || Object(external_lodash_["isArray"])(obj)) {
        return Object(external_lodash_["keys"])(obj).map(function (mapKey, index, properties) {
          var value = obj[mapKey]; // TS: should be safe based on (recursive) JSONElement type

          var key = Object(external_lodash_["isArray"])(obj) ? parseInt(mapKey, 10) : mapKey;
          var propertyDataPath = path.length === 0 ? ".".concat(key) : ".".concat(path.join('.'), ".").concat(key);

          var representation = _this4.renderValue({
            key: key,
            value: value
          });

          var propertyElement = !Object(external_lodash_["isArray"])(obj) ? _this4.renderKey(key) : undefined;
          return /*#__PURE__*/external_react_default.a.createElement("div", {
            key: propertyDataPath,
            role: "treeitem",
            "data-test-path": propertyDataPath
          }, _this4.regularIndent, propertyElement, representation, index + 1 < properties.length ? ',' : null);
        });
      } // edge case: a single number/string/boolean being rendered (still valid JSON)


      return /*#__PURE__*/external_react_default.a.createElement("div", {
        role: "treeitem",
        "data-test-path": "."
      }, this.renderValue({
        value: obj
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var obj = this.props.obj;
      var isExpandable = Object(external_lodash_["isObject"])(obj) && !Object(external_lodash_["isEmpty"])(obj) || Object(external_lodash_["isArray"])(obj) && obj.length > 0;
      return /*#__PURE__*/external_react_default.a.createElement("span", {
        "data-test": isExpandable ? 'node' : null,
        "data-test-expanded": isExpandable ? this.state.open : null
      }, isExpandable && (Object(external_lodash_["isArray"])(obj) ? '[' : '{'), isExpandable && this.renderExpandLink(), !isExpandable || open ? this.renderObject() : null, !isExpandable || open ? this.closingIndent : null, isExpandable && (Object(external_lodash_["isArray"])(obj) ? ']' : '}'));
    }
  }]);

  return JSONTreeNode;
}(external_react_["Component"]);

_defineProperty(TreeNode_JSONTreeNode, "propTypes", propTypes);

_defineProperty(TreeNode_JSONTreeNode, "defaultProps", defaultProps);

/* harmony default export */ var TreeNode = (TreeNode_JSONTreeNode);
// CONCATENATED MODULE: ./src/JSONTree/JSONTreeStyles.ts


var base = Object(external_styled_components_["css"])(["", ";font-family:", ";"], themes_["mixins"].reset('block'), themes_["variables"].monoFontFamily);
var StyledScrollCode = external_styled_components_default.a.code.withConfig({
  displayName: "JSONTreeStyles__StyledScrollCode",
  componentId: "vrdt21-0"
})(["", ";overflow-x:auto;white-space:nowrap;"], base);
var StyledWrapCode = external_styled_components_default.a.code.withConfig({
  displayName: "JSONTreeStyles__StyledWrapCode",
  componentId: "vrdt21-1"
})(["", ";white-space:pre-wrap;"], base);

// CONCATENATED MODULE: ./src/JSONTree/JSONTree.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var JSONTree_propTypes = {
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  json: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object, external_prop_types_default.a.array, external_prop_types_default.a.number, external_prop_types_default.a.bool]).isRequired,
  indent: external_prop_types_default.a.number,
  onClickKey: external_prop_types_default.a.func,
  onClickValue: external_prop_types_default.a.func,
  expandChildren: external_prop_types_default.a.bool,
  overflow: external_prop_types_default.a.oneOf(['wrap', 'scroll'])
};

/**
 * Used to visualize a JSON string.
 */
function JSONTree(_ref) {
  var elementRef = _ref.elementRef,
      _ref$expandChildren = _ref.expandChildren,
      expandChildren = _ref$expandChildren === void 0 ? false : _ref$expandChildren,
      _ref$indent = _ref.indent,
      indent = _ref$indent === void 0 ? 4 : _ref$indent,
      json = _ref.json,
      onClickKey = _ref.onClickKey,
      onClickValue = _ref.onClickValue,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === void 0 ? 'scroll' : _ref$overflow,
      otherProps = _objectWithoutProperties(_ref, ["elementRef", "expandChildren", "indent", "json", "onClickKey", "onClickValue", "overflow"]);

  // @docs-props-type JSONTreePropsBase
  var obj = Object(external_lodash_["isString"])(json) ? JSON.parse(json) : json;
  var StyledCode = overflow === 'wrap' ? StyledWrapCode : StyledScrollCode;
  return /*#__PURE__*/external_react_default.a.createElement(StyledCode, _extends({
    "data-language": "language-json",
    "data-test": "json-tree",
    ref: elementRef,
    role: "tree"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement(TreeNode, {
    defaultOpen: true,
    expandChildren: expandChildren,
    indent: indent,
    obj: obj,
    onClickKey: onClickKey,
    onClickValue: onClickValue,
    overflow: overflow
  }));
}

JSONTree.propTypes = JSONTree_propTypes;
/* harmony default export */ var JSONTree_JSONTree = (JSONTree);
// CONCATENATED MODULE: ./src/JSONTree/index.ts



/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ })

/******/ });